export const useTrack = () => {
	const track = (event: string, data?: Record<string, string>) => {
		sendGoogleEvent(event, data)
	}

	const sendGoogleEvent = (event: string, data?: Record<string, string>) => {
		if (typeof window !== 'undefined' && 'gtag' in window) {
			// biome-ignore lint/suspicious/noExplicitAny: gtag is a global function from GTM
			;(window as any).gtag('event', event, {
				...data,
			})
		}
	}

	return { track, sendGoogleEvent }
}
